import { TableRowVariantTypeV2 } from '../variants';
export const getBodyRowStyles = (FOUNDATIONS, FONT) => {
    return {
        [TableRowVariantTypeV2.BODY_ROW]: {
            container: {
                display: 'table-row',
                border_bottom: `${FOUNDATIONS.spacing_25} solid ${FOUNDATIONS.color_comp_tableslist_lineseparator_regular_border}`,
            },
            hoveredCellContainer: {
                background_color: FOUNDATIONS.color_neutral_bg_300,
            },
            activeCellContainer: {
                // At the moment, we don't have a specific color for active row
                background_color: '#E6F6FE',
            },
        },
    };
};
//# sourceMappingURL=bodyRow.js.map